module.exports = __webpack_public_path__ + "img/cashout.958b3a3d.svg";